const catalogue1 = (data) => {
  const node = data.node;
  const catalogueList = node.list;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style="text-align: left;"><span style="font-size: 16.40625px;font-family: Microsoft Yahei;">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "jnYTdeU3p1",
        width: 230.40818897637794,
        height: 280.6118635170604,
        left: 93.56629921259842,
        top: 0,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}75`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "5ZhbOTq2DS",
        width: 230.40818897637794,
        height: 230.40818897637794,
        left: 93.56629921259842,
        top: 162.6701312335958,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "9ZeNZtDhEi",
        width: 164.41070866141735,
        height: 50,
        left: 164.60830265808863,
        top: 214.2183727034121,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content:
          '<p style="text-align: left;"><span style="color: #FFFFFF;font-size: 10.9375px;font-family: Microsoft Yahei;">CATALOGUE</span></p>',
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "dvdpBb8_rN",
        width: 230.40818897637791,
        height: 90.3125,
        left: 93.56629921259842,
        top: 239.4371128608924,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content:
          '<p style="text-align: center;"><span style="font-size: 46.875px;"><span style="font-family: Microsoft Yahei;"><span style="color: #FFFFFF;">目录</span></span></span></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "V33g5l5bYX",
        width: 490.77028871391076,
        height: 190,
        left: 438.38435695538055,
        top: 140.3059317585302,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "tEqa3ne69w",
        width: 21.289868766404197,
        height: 115.54635170603675,
        left: 50.15958005249344,
        top: 203.57343832021,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}75`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "P_oeEgV2-i",
        width: 21.289868766404197,
        height: 21.289868766404197,
        left: 50.15958005249344,
        top: 192.9285039370079,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "he1uF2_MD9",
        width: 148.70488188976378,
        height: 148.70488188976378,
        left: -83.84356955380578,
        top: 399.39758530183724,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}75`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "1F9aM3pPRQ",
        width: 54.85858267716535,
        height: 157.0997375328084,
        left: 352.56535433070866,
        top: 0,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}75`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hbbcT4ycV6",
        width: 54.85858267716535,
        height: 54.85858267716535,
        left: 352.56535433070866,
        top: 129.67044619422572,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "74xdE5gcij",
        width: 43.57354330708661,
        height: 43.57354330708661,
        left: 825.6797900262468,
        top: 484.96325459317586,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}75`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Z_Vw7fmD8I",
        width: 198.7896062992126,
        height: 198.7896062992126,
        left: 884.1516010498688,
        top: -41.689868766404196,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}75`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "line",
        id: "CnyFU2iR8j",
        width: 0.75,
        left: 262.3441469816273,
        top: 237.65133858267717,
        start: [0, 0],
        end: [0, 10.740787401574803],
        style: "solid",
        color: "#FFFFFF",
        points: ["", ""],
      },
      {
        type: "line",
        id: "bvCsSMw7yQ",
        width: 0.75,
        left: 149.56503937007875,
        top: 237.65133858267717,
        start: [0, 0],
        end: [0, 10.740787401574803],
        style: "solid",
        color: "#FFFFFF",
        points: ["", ""],
      },
    ],
    background: {
      type: "solid",
      color: `#fff`,
    },
  };
};

export default catalogue1;
